// modalListeners.ts

import { disableScrollLock, enableScrollLock } from '../utils/scrollLock';

/** Modal Toggling **/
export function handleModalToggling(): void {
	const modalToggles = document.querySelectorAll<HTMLElement>('[data-modal-target]');

	modalToggles.forEach((toggle) => {
		const openModal = (ev: Event, focusOnOpen: boolean) => {
			const modalId = toggle.dataset.modalTarget as string | null;
			if (!modalId) return;

			if (toggle.tagName === 'A' && (toggle as HTMLAnchorElement).hasAttribute('href'))
				ev.preventDefault();
			enableScrollLock();
			toggleModal(modalId);

			if (focusOnOpen) {
				const modal = document.getElementById(modalId);
				if (modal) {
					if (!modal.hasAttribute('tabindex')) {
						modal.setAttribute('tabindex', '-1'); // allow focus if not already focusable
					}
					modal.focus();
				}
			}
		};

		toggle.addEventListener('click', (e: Event) => openModal(e, false));

		toggle.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				openModal(e, true);
			}
		});
	});
}

/**
 * Toggles modals.
 * @param {string} modalId - The ID of the target modal.
 */
export function toggleModal(modalId: String): void {
	const body = document.querySelector('body') as HTMLElement;
	const modal = document.querySelector('#' + modalId) as HTMLElement;
	const closeElems = ['wc-modal__close', 'wc-checkout-modal__btn-close', 'wc-modal__overlay'];
	const exemptFromClose = ['wc-consent-manage-modal', 'wc-consent-modal', 'wc-age-gate-modal'];
	const active = 'modal-active';
	const trans = 'modal-transition';
	if (!body && !modal) return;

	if (!body.classList.contains(active)) {
		body.classList.add(active);
	}

	modal?.classList.add(active, trans);

	modal?.addEventListener(
		'transitionend',
		() => {
			setTimeout(function () {
				modal?.classList.remove(trans);
			}, 500);
		},
		{ once: true },
	);

	const isExempt = exemptFromClose.some((className) => modal.classList.contains(className));
	if (isExempt) return;

	closeElems.forEach((el) => {
		if (!el) return;
		const closeElem = modal.querySelector('.' + el) as HTMLElement;
		if (closeElem) {
			closeElem.addEventListener('click', () => {
				modal.classList.remove(active);
				body.classList.remove(active);
				disableScrollLock();
			});
		}
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && !modal.classList.contains('modal-prevent-close')) {
			modal.classList.remove(active);
			body.classList.remove(active);
			disableScrollLock();
		}
	});
}
